var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"themeToggleButton"}},[_c('div',{staticClass:"toggleContainer",on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggleBall",class:{ active: _vm.isDarkThemeActive }},[_c('img',{staticClass:"toggleIcon",attrs:{"src":this.currentTheme === 'lightTheme'
            ? require('../assets/img/icons/moon.svg')
            : require('../assets/img/icons/sun.svg'),"alt":this.currentTheme === 'lightTheme' ? 'moon icon' : 'sun icon'}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }